import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  HStack,
  Input,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const RunsSection = ({
  canManagePayroll,
  runForm,
  setRunForm,
  handleCreateRun,
  payrollRuns,
  handleRunAction,
}) => {
  return (
    <Stack spacing={6}>
      {canManagePayroll ? (
        <Card>
          <CardHeader>
            <CardHeadingWithHelp
              title="Create Payroll Run"
              helpText={CARD_HELP_TEXT.createRun}
            />
          </CardHeader>
          <CardBody>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
              <FormControl>
                <FormLabel>Month</FormLabel>
                <Input
                  value={runForm.month}
                  onChange={(e) =>
                    setRunForm((prev) => ({
                      ...prev,
                      month: e.target.value,
                    }))
                  }
                  type="number"
                  min="1"
                  max="12"
                />
              </FormControl>
              <FormControl>
                <FormLabel>Year</FormLabel>
                <Input
                  value={runForm.year}
                  onChange={(e) =>
                    setRunForm((prev) => ({
                      ...prev,
                      year: e.target.value,
                    }))
                  }
                  type="number"
                />
              </FormControl>
              <FormControl alignSelf="end">
                <Button
                  colorScheme="blue"
                  onClick={handleCreateRun}
                  width="full"
                >
                  Create Run
                </Button>
              </FormControl>
            </SimpleGrid>
          </CardBody>
        </Card>
      ) : null}

      <Card>
        <CardHeader>
          <CardHeadingWithHelp
            title="Payroll Runs"
            helpText={CARD_HELP_TEXT.payrollRuns}
          />
        </CardHeader>
        <CardBody>
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Month</Th>
                  <Th>Status</Th>
                  <Th>Employees</Th>
                  <Th>Processed</Th>
                  <Th>Finalized</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {payrollRuns.map((run) => (
                  <Tr key={run._id}>
                    <Td>{`${run.month}/${run.year}`}</Td>
                    <Td>
                      <Badge
                        colorScheme={
                          run.status === "FINALIZED"
                            ? "green"
                            : run.status === "PROCESSING"
                              ? "orange"
                              : "gray"
                        }
                      >
                        {run.status}
                      </Badge>
                    </Td>
                    <Td>{run.totalEmployees || 0}</Td>
                    <Td>{run.processedEmployees || 0}</Td>
                    <Td>
                      {run.finalizedAt
                        ? new Date(run.finalizedAt).toLocaleString()
                        : "-"}
                    </Td>
                    <Td>
                      <HStack>
                        {canManagePayroll ? (
                          <>
                            <Button
                              size="xs"
                              onClick={() =>
                                handleRunAction("process", run._id)
                              }
                            >
                              Process
                            </Button>
                            <Button
                              size="xs"
                              colorScheme="green"
                              onClick={() =>
                                handleRunAction("finalize", run._id)
                              }
                              isDisabled={run.status === "FINALIZED"}
                            >
                              Finalize
                            </Button>
                          </>
                        ) : null}
                      </HStack>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default RunsSection;
